// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const NoLensesToDisplay = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.noLensesToDisplay"
        description="No lenses to display."
        defaultMessage="No Lens+ Lenses to display."
    />
);
NoLensesToDisplay.displayName = "NoLensesToDisplay";

export const DailyBreakdown = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.dailyBreakdown"
        description="Daily breakdown."
        defaultMessage="Day"
    />
);
DailyBreakdown.displayName = "DailyBreakdown";

export const LensesTitle = (props: { month: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.lensesTitle"
        description="Lenses title."
        defaultMessage="Your Lens+ Lenses · {month}"
        values={props}
    />
);
LensesTitle.displayName = "LensesTitle";

export const NoDailyData = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.noDailyData"
        description="No daily data."
        defaultMessage="Daily breakdown data is not available for this month."
    />
);
NoDailyData.displayName = "NoDailyData";

export const PaidEarnings = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.paidEarnings"
        description="Paid earnings."
        defaultMessage="Paid earnings"
    />
);
PaidEarnings.displayName = "PaidEarnings";

export const PaidEarningsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.paidEarningsTooltip"
        description="Paid earnings tooltip."
        defaultMessage="The amount paid for the selected month's Lens+ activity. Pending payments are not included."
    />
);
PaidEarningsTooltip.displayName = "PaidEarningsTooltip";

export const SignupPrivacy = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.signupPrivacy"
        description="Signup privacy."
        defaultMessage="Signup counts below 10 are shown as <10."
    />
);
SignupPrivacy.displayName = "SignupPrivacy";

export const Estimated = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.estimated"
        description="Estimated."
        defaultMessage="Current figures are estimates until the month is finalized."
    />
);
Estimated.displayName = "Estimated";

export const CreatorScope = (): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.creatorScope"
        description="Creator scope."
        defaultMessage="Includes your Lens+ activity across all folders."
    />
);
CreatorScope.displayName = "CreatorScope";

export const StatusLabel = (props: { status: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.statusLabel"
        description="Status label."
        defaultMessage="{status, select, pending {Pending} onTrack {On track} belowMinimum {Below minimum} noActivity {No activity yet} notEligible {Not eligible} noPayout {No payout} awaiting {Awaiting metrics} paid {Paid} other {Unavailable}}"
        values={props}
    />
);
StatusLabel.displayName = "StatusLabel";

export const MonthScore = (props: { month: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.monetization.components.lensPlus.monthScore"
        description="Month score."
        defaultMessage="{month} Score"
        values={props}
    />
);
MonthScore.displayName = "MonthScore";

export const messages = defineMessages({
    calendarNote: {
        id: "apps.monetization.components.lensPlus.calendarNote",
        description: "Calendar note.",
        defaultMessage:
            "Lens+ payouts are calculated per calendar month. Each month starts fresh. Activity never rolls over.",
    },
    cycleTitle: {
        id: "apps.monetization.components.lensPlus.cycleTitle",
        description: "Cycle title.",
        defaultMessage: "{month} payout cycle",
    },
    cycleSubtitle: {
        id: "apps.monetization.components.lensPlus.cycleSubtitle",
        description: "Cycle subtitle.",
        defaultMessage:
            "{current, select, true {Day {day} of {days} · your payout is finalized after the month closes} other {This calendar month has closed.}}",
    },
    cycleStarted: {
        id: "apps.monetization.components.lensPlus.cycleStarted",
        description: "Cycle started.",
        defaultMessage: "{date}: Earning started",
    },
    cycleToday: {
        id: "apps.monetization.components.lensPlus.cycleToday",
        description: "Cycle today.",
        defaultMessage: "Today, {date}",
    },
    cycleCloses: {
        id: "apps.monetization.components.lensPlus.cycleCloses",
        description: "Cycle closes.",
        defaultMessage: "{date}: Month closes",
    },
    cycleReset: {
        id: "apps.monetization.components.lensPlus.cycleReset",
        description: "Cycle reset.",
        defaultMessage: "Score reset to 0",
    },
    cycleClosed: {
        id: "apps.monetization.components.lensPlus.cycleClosed",
        description: "Cycle closed.",
        defaultMessage: "Month closed",
    },
    cycleUpdates: {
        id: "apps.monetization.components.lensPlus.cycleUpdates",
        description: "Cycle updates.",
        defaultMessage: "Lens+ metrics update daily",
    },
    cyclePayoutBy: {
        id: "apps.monetization.components.lensPlus.cyclePayoutBy",
        description: "Cycle payout by.",
        defaultMessage: "Payout on the 5th of the following month, around 5:30pm Pacific",
    },
    summaryTitle: {
        id: "apps.monetization.components.lensPlus.summaryTitle",
        description: "Summary title.",
        defaultMessage: "{month} {current, select, true {so far} other {summary}}",
    },
    summaryNote: {
        id: "apps.monetization.components.lensPlus.summaryNote",
        description: "Summary note.",
        defaultMessage: "These three numbers drive your payout. They reset every month.",
    },
    statusLabel: {
        id: "apps.monetization.components.lensPlus.statusLabel",
        description: "Status label.",
        defaultMessage:
            "{status, select, pending {Pending} onTrack {On track} belowMinimum {Below minimum} noActivity {No activity yet} notEligible {Not eligible} noPayout {No payout} awaiting {Awaiting metrics} paid {Paid} other {Unavailable}}",
    },
    payoutTiming: {
        id: "apps.monetization.components.lensPlus.payoutTiming",
        description: "Payout timing.",
        defaultMessage: "Finalized after {closeDate}. Paid on the 5th of the following month, around 5:30pm Pacific.",
    },
    stepTitle: {
        id: "apps.monetization.components.lensPlus.stepTitle",
        description: "Step title.",
        defaultMessage:
            "{step, select, users {Lens+ subscribers use your Lens} score {Your monthly score builds} other {You’re paid the following month}}",
    },
    stepBody: {
        id: "apps.monetization.components.lensPlus.stepBody",
        description: "Step body.",
        defaultMessage:
            "{step, select, users {Only Lens+ subscriber activity counts. Reach and Plays from everyone else don’t affect payouts.} score {Score = Lens+ Users + Signups × 100. It counts this month only and resets on the 1st.} other {Your score determines your share of the monthly pool, paid on the 5th of the following month, around 5:30pm Pacific.}}",
    },
    historyTitle: {
        id: "apps.monetization.components.lensPlus.historyTitle",
        description: "History title.",
        defaultMessage: "Payout history",
    },
    historyMonthly: {
        id: "apps.monetization.components.lensPlus.historyMonthly",
        description: "History monthly.",
        defaultMessage: "Month",
    },
    lensesSubtitle: {
        id: "apps.monetization.components.lensPlus.lensesSubtitle",
        description: "Lenses subtitle.",
        defaultMessage: "Every Lens enrolled in Lens+ appears here, including ones that haven’t earned yet.",
    },
    lensesSubmitted: {
        id: "apps.monetization.components.lensPlus.lensesSubmitted",
        description: "Lenses submitted.",
        defaultMessage: "Lenses submitted",
    },
    lensesScored: {
        id: "apps.monetization.components.lensPlus.lensesScored",
        description: "Lenses scored.",
        defaultMessage: "Scored {minimum}+",
    },
    lensesHitRate: {
        id: "apps.monetization.components.lensPlus.lensesHitRate",
        description: "Lenses hit rate.",
        defaultMessage: "Hit rate",
    },
    lensesSummaryNote: {
        id: "apps.monetization.components.lensPlus.lensesSummaryNote",
        description: "Lenses summary note.",
        defaultMessage:
            "{kind, select, submitted {Enrolled Lenses, including inactive ones} scored {Lenses at or above the monthly minimum score} other {Scored {minimum}+ ÷ submitted}}",
    },
    availableScoredNote: {
        id: "apps.monetization.components.lensPlus.availableScoredNote",
        description:
            "Explains partial Scored minimum+ counts and hit rates when some monthly Lens metrics are missing.",
        defaultMessage:
            "Counts use available monthly metrics. Metrics for {count, plural, one {# Lens is unavailable.} other {# Lenses are unavailable.}}",
    },
    projected: {
        id: "apps.monetization.components.lensPlus.projected",
        description: "Projected.",
        defaultMessage: "Projected",
    },
    scoreReset: {
        id: "apps.monetization.components.lensPlus.scoreReset",
        description: "Score reset.",
        defaultMessage: "Resets {date}",
    },
    lastPayout: {
        id: "apps.monetization.components.lensPlus.lastPayout",
        description: "Last payout.",
        defaultMessage: "Last payout",
    },
    lastPayoutMonth: {
        id: "apps.monetization.components.lensPlus.lastPayoutMonth",
        description: "Last payout month.",
        defaultMessage: "for {month}",
    },
    retry: {
        id: "apps.monetization.components.lensPlus.retry",
        description: "Retry loading the next page of Lens+ lenses.",
        defaultMessage: "Try again",
    },
    historicalMetricsUnavailable: {
        id: "apps.monetization.components.lensPlus.historicalMetricsUnavailable",
        description: "Historical metrics unavailable.",
        defaultMessage: "Activity metrics are unavailable for this closed month.",
    },
    historicalLensesSubtitle: {
        id: "apps.monetization.components.lensPlus.historicalLensesSubtitle",
        description: "Historical lenses subtitle.",
        defaultMessage: "Lenses with historical paid records appear here.",
    },
    signupChartPrivacy: {
        id: "apps.monetization.components.lensPlus.signupChartPrivacy",
        description: "Signup chart privacy.",
        defaultMessage: "Daily signup counts below 10 are shown as <10.",
    },
    monthly: {
        id: "apps.monetization.components.lensPlus.monthly",
        description: "Monthly.",
        defaultMessage: "Monthly",
    },
    allTimeNote: {
        id: "apps.monetization.components.lensPlus.allTimeNote",
        description: "All time note.",
        defaultMessage:
            "Totals include available monthly activity, including the current month and months that have not been paid. Some older activity data may be unavailable.",
    },
    totalPaid: {
        id: "apps.monetization.components.lensPlus.totalPaid",
        description: "Total paid.",
        defaultMessage: "Total paid out",
    },
    loadOlder: {
        id: "apps.monetization.components.lensPlus.loadOlder",
        description: "Load older.",
        defaultMessage: "Load older months",
    },
    paidOn: {
        id: "apps.monetization.components.lensPlus.paidOn",
        description: "Paid on.",
        defaultMessage: "Paid {date}",
    },
    scoreFinal: {
        id: "apps.monetization.components.lensPlus.scoreFinal",
        description: "Score final.",
        defaultMessage: "Final",
    },
    refreshFailed: {
        id: "apps.monetization.components.lensPlus.refreshFailed",
        description: "Refresh failed.",
        defaultMessage: "Unable to refresh. Showing the last loaded data.",
    },
    lifetimeMetricNote: {
        id: "apps.monetization.components.lensPlus.lifetimeMetricNote",
        description: "Lifetime metric note.",
        defaultMessage:
            "{kind, select, subscriberActionsUu {Sum of monthly Lens+ Users across Lenses and months. A subscriber can count for each Lens and month.} subscribeCount {Lens+ signups from available monthly activity. Each signup adds 100 points.} other {Sum of available monthly scores. Each month is scored separately.}}",
    },
    lifetime: {
        id: "apps.monetization.components.lensPlus.lifetime",
        description: "Lifetime.",
        defaultMessage: "Available history",
    },
    totalPaidNote: {
        id: "apps.monetization.components.lensPlus.totalPaidNote",
        description: "Total paid note.",
        defaultMessage: "Paid Lens+ payouts across all available history.",
    },
    comparedWithMonth: {
        id: "apps.monetization.components.lensPlus.comparedWithMonth",
        description: "Compared with month.",
        defaultMessage: "vs {month}{partial, select, true { (full month)} other {}}",
    },
    allTimeLenses: {
        id: "apps.monetization.components.lensPlus.allTimeLenses",
        description: "All time lenses.",
        defaultMessage: "Available history",
    },
    allTimeLensesNote: {
        id: "apps.monetization.components.lensPlus.allTimeLensesNote",
        description: "All time lenses note.",
        defaultMessage:
            "Includes Lenses with available monthly activity or paid history, including unpaid Lenses. Older activity may be unavailable.",
    },
    searchLenses: {
        id: "apps.monetization.components.lensPlus.searchLenses",
        description: "Search lenses.",
        defaultMessage: "Search Lenses",
    },
    inspectLens: {
        id: "apps.monetization.components.lensPlus.inspectLens",
        description: "Inspect lens.",
        defaultMessage: "Inspect {name}",
    },
    lensPages: {
        id: "apps.monetization.components.lensPlus.lensPages",
        description: "Lens pages.",
        defaultMessage:
            "{count} Lenses loaded. Loading the remaining Lenses in the background for complete search and sorting.",
    },
    partialTotals: {
        id: "apps.monetization.components.lensPlus.partialTotals",
        description: "Partial totals.",
        defaultMessage:
            "{count, plural, =0 {Estimate} other {Partial estimate}} from available monthly Lens metrics. {count, plural, =0 {} one {Metrics for # Lens is unavailable. } other {Metrics for # Lenses are unavailable. }}Totals may change as data is updated.",
    },
    dailyUsersNote: {
        id: "apps.monetization.components.lensPlus.dailyUsersNote",
        description: "Daily users note.",
        defaultMessage:
            "Daily users are deduplicated per Lens within each day. Monthly users are deduplicated per Lens, so daily counts do not add up to the monthly total. Only days with available data are shown.",
    },
    loadingTotals: {
        id: "apps.monetization.components.lensPlus.loadingTotals",
        description: "Loading totals.",
        defaultMessage: "Loading monthly totals…",
    },
    loadingLensMatches: {
        id: "apps.monetization.components.lensPlus.loadingLensMatches",
        description: "Loading lens matches.",
        defaultMessage: "More Lenses are loading. Matching results will appear as they arrive.",
    },
    incompleteLensMatches: {
        id: "apps.monetization.components.lensPlus.incompleteLensMatches",
        description: "Incomplete lens matches.",
        defaultMessage: "No matches in the loaded Lenses. Try again to load the remaining Lenses.",
    },
    unavailableTotals: {
        id: "apps.monetization.components.lensPlus.unavailableTotals",
        description: "Unavailable totals.",
        defaultMessage:
            "Monthly metrics are unavailable for {count, plural, one {# Lens} other {# Lenses}}. A monthly total is not available.",
    },
    availableTotalsNote: {
        id: "apps.monetization.components.lensPlus.availableTotalsNote",
        description: "Available totals note.",
        defaultMessage:
            "{count, plural, =0 {Available monthly Lens metrics.} one {Partial totals from available monthly Lens metrics. Metrics for # Lens is unavailable.} other {Partial totals from available monthly Lens metrics. Metrics for # Lenses are unavailable.}}",
    },
});
